<ng-container *hasPermission="['INSPECTION_CONFIGURATION_READ','INSPECTION_CONFIGURATION_ALL']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Elenco camere</h2>
        </div>
        <app-filter-panel [criteria]="searchCriteria">
            <ng-template #fields>
                <form [formGroup]="searchForm" (ngSubmit)="search()">
                    <div class="row">
                        <div class="mb-4">
                            <label for="name" class="form-label">Provider</label>
                            <input type="text" class="form-control" id="name" name="name" formControlName="provider" />
                        </div>
                    </div>

                    <div class="d-flex justify-content-end  align-items-center col-12 m-2 gap-2">
                        <button type="button" class="btn  btn-outline-secondary"
                            (click)="clearFilter()">Cancella</button>
                        <button type="submit" class="btn btn-primary">Cerca</button>
                    </div>
                </form>
            </ng-template>
        </app-filter-panel>
        <div class="section-container">
            <div class="table-responsive">
                <table class="table caption-top table-hover table-striped">
                    <caption>
                        <button type="button" class="btn btn-primary" (click)="edit(0)"
                            *hasPermission="['INSPECTION_CONFIGURATION_CREATE','INSPECTION_CONFIGURATION_ALL']"><i
                                bTooltip title="Aggiungi" class="fa-solid fa-plus"></i></button>
                        Risultati trovati: {{totalItems}}
                    </caption>
                    <thead>
                        <tr>
                            <th scope="col" class="row-button-sm"></th>
                            <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'provider'"
                                [colValue]="'Provider'" [baseSearchCriteria]="searchCriteria"
                                (orderingClick)="ordering($event)"></th>
                            <th scope="col">Attiva</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let inspectionConfiguration of inspectionConfigurations | paginate: {
                        itemsPerPage: searchCriteria.pageSize,
                        currentPage: searchCriteria.pageNumber,
                        totalItems: totalItems } ">
                            <td>
                                <div class="d-flex justify-content-center  align-items-center gap-2">
                                    <div class="cursor-pointer" (click)="edit(inspectionConfiguration.id!)"
                                        *hasPermission="['INSPECTION_CONFIGURATION_READ','INSPECTION_CONFIGURATION_ALL']">
                                        <i bTooltip title="Modifica" class="fa-solid fa-pen"></i>
                                    </div>
                                    <div class="cursor-pointer"
                                        (click)="confirmOperation(inspectionConfiguration,'DEL')"
                                        *hasPermission="['INSPECTION_CONFIGURATION_DELETE','INSPECTION_CONFIGURATION_ALL']">
                                        <i bTooltip title="Elimina" class="fa-solid fa-trash"></i>
                                    </div>

                                </div>
                            </td>
                            <td>{{computeNameType(inspectionConfiguration.provider!!)}}</td>
                            <td>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                        [checked]="inspectionConfiguration.active" disabled
                                        [id]="'inspectionConfigActive-'+inspectionConfiguration.id">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <pagination-controls (pageChange)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)"
                previousLabel="Precedente" nextLabel="Successiva" screenReaderPaginationLabel="Paginazione"
                screenReaderPageLabel="Pagina" screenReaderCurrentLabel="Vai alla pagina">
            </pagination-controls>
        </div>
    </div>
    <app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
        (modalConfirm)="modalOperationExec()" (modalCancel)="cancelModalOperationExec()">
    </app-confirm-alert>
</ng-container>